















































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import api from '../../../api/index'

@Component
export default class DelegationForm extends Vue {
  @Prop({ type: Boolean, required: true }) isActive!: boolean
  @Prop({ type: Object, default: () => ({}) }) editedDelegation!: any
  @Getter('admin') isAdmin!: boolean

  condominiums: any[] = []
  condominiumSearch = ''
  selectedCondominiums: any[] = []

  managerResults: any[] = []
  managerSearch = ''
  selectedManager: any = null

  dragCounter = 0
  managerSearchTimer?: number = undefined

  errorMessage: string[] = []

  fields = {
    title: {
      value: '',
      check: v => v.length > 0,
      isValid: null as boolean | null,
      error: 'L\'intitulé doit être défini'
    },
    manager_id: {
      value: null as number | null,
      check: v => v !== null,
      isValid: null as boolean | null,
      error: 'Un gestionnaire doit être sélectionné'
    },
    all_condominiums: {
      value: false
    },
    condominium_ids: {
      value: [] as any[],
      check: v => v.length > 0,
      isValid: null as boolean | null,
      error: 'Au moins 1 site doit être sélectionné'
    },
    import_file: {
      value: null as File | null,
      check: v => v !== null,
      isValid: null as boolean | null,
      error: 'Un fichier .xlsx doit être sélectionné'
    }
  }

  get isEditMode() {
    return this.editedDelegation && this.editedDelegation.id
  }

  get xlsExampleUrl() {
    return '//' + process.env.VUE_APP_API_HOST + '/utilisateurs-groupes.xlsx'
  }

  @Watch('editedDelegation', { immediate: true })
  hydrateForm() {
    if (!this.isEditMode) {
      this.resetForm()
      return
    }
    const d = this.editedDelegation
    this.fields.title.value = d.title || ''
    this.fields.all_condominiums.value = d.all_condominiums || false
    if (d.manager) {
      this.selectedManager = d.manager
      this.fields.manager_id.value = d.manager.id
    }
    this.selectedCondominiums = d.condominiums ? [...d.condominiums] : []
  }

  get filteredManagers() {
    return this.managerResults
  }

  searchManagers(query: string) {
    if (this.managerSearchTimer) clearTimeout(this.managerSearchTimer)
    if (query.length < 2) return
    this.managerSearchTimer = setTimeout(async () => {
      try {
        const res = await api.get('bo/users', { params: { keywords: query, imported_type: 'manager', per_page: 10 } })
        this.managerResults = res.data
      } catch (e) {
        console.log(e)
      }
    }, 500)
  }

  selectManager(manager: any) {
    if (!manager) return
    this.selectedManager = manager
    this.fields.manager_id.value = manager.id
  }

  get filteredCondominiums() {
    const search = this.condominiumSearch.toLowerCase()
    const selectedIds = this.selectedCondominiums.map(c => c.id)
    return this.condominiums
      .filter(c => !selectedIds.includes(c.id))
      .filter(c =>
        c.title.toLowerCase().includes(search) ||
        c.reference.toLowerCase().includes(search)
      )
  }

  handleDrop(e) {
    this.dragCounter = 0
    const files = e.dataTransfer.files
    if (files.length === 0) return
    this.fileSelected(files[0])
  }

  fileSelected(file?: File) {
    this.errorMessage = []
    if (!file) return
    if (!this.isAcceptedFileType(file)) {
      this.errorMessage.push('Seuls les fichiers .xlsx sont acceptés')
      return
    }
    this.fields.import_file.value = file
    this.fields.import_file.isValid = null
  }

  isAcceptedFileType(file: File) {
    return /\.xlsx$/i.test(file.name)
  }

  validateForm() {
    this.fields.condominium_ids.value = this.selectedCondominiums.map(c => c.id)

    Object.keys(this.fields)
      .filter(field => this.fields[field].check !== undefined)
      .forEach(field => {
        if (field === 'condominium_ids' && this.fields.all_condominiums.value) {
          this.fields[field].isValid = true
          return
        }
        if (field === 'manager_id' && !this.isAdmin) {
          this.fields[field].isValid = true
          return
        }
        if (field === 'import_file' && this.isEditMode) {
          this.fields[field].isValid = true
          return
        }
        this.fields[field].isValid = this.fields[field].check(this.fields[field].value)
      })
    return !Object.keys(this.fields).some(field => this.fields[field].isValid === false)
  }

  async saveDelegation() {
    this.errorMessage = []
    if (!this.validateForm()) return

    const form = new FormData()
    form.append('delegation[title]', this.fields.title.value)
    form.append('delegation[all_condominiums]', String(this.fields.all_condominiums.value))
    if (this.isAdmin && this.selectedManager) {
      form.append('delegation[manager_id]', String(this.selectedManager.id))
    }
    if (!this.fields.all_condominiums.value) {
      this.selectedCondominiums.forEach(c => {
        form.append('delegation[condominium_ids][]', String(c.id))
      })
    }
    if (this.fields.import_file.value) {
      form.append('delegation[import_file]', this.fields.import_file.value)
    }

    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      if (this.isEditMode) {
        await api.put(`bo/delegations/${this.editedDelegation.id}`, form, config)
      } else {
        await api.post('bo/delegations', form, config)
      }
      this.closeModal()
      this.$emit('success')
    } catch (error) {
      if (error.response && error.response.status === 422 && Array.isArray(error.response.data.errors)) {
        this.errorMessage = error.response.data.errors.map(err => (
          err && err.line_number !== undefined ? `Ligne: ${err.line_number} - ${err.title}` : err
        ))
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }

  closeModal() {
    this.errorMessage = []
    this.resetForm()
    this.$emit('close')
  }

  resetForm() {
    this.fields.title.value = ''
    this.fields.title.isValid = null
    this.fields.manager_id.value = null
    this.fields.manager_id.isValid = null
    this.selectedManager = null
    this.managerResults = []
    this.managerSearch = ''
    this.fields.all_condominiums.value = false
    this.fields.condominium_ids.value = []
    this.fields.condominium_ids.isValid = null
    this.selectedCondominiums = []
    this.dragCounter = 0
    this.fields.import_file.value = null
    this.fields.import_file.isValid = null
  }

  @Watch('isActive')
  async onActiveChange(val: boolean) {
    if (!val) return
    try {
      const res = await api.get('bo/condominiums', { params: { per_page: 100 } })
      this.condominiums = res.data
    } catch (e) {
      console.log(e)
    }
  }
}
